import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { Fab } from '@material-ui/core';

import { ReactComponent as DarfIcon } from '../../assets/icons/ubr_darf.svg';
import { ReactComponent as QuestionIcon } from '../../assets/icons/ubr_question.svg';
import api from '../../services/api';
import { hash } from '../../utils/hashGenerator';
import Accordion from '../Accordion';
import Button from '../Button';
import Modal from '../Modal';
import {
  Container,
  Hamburger,
  ActionsFab,
  DataFile,
  DataWrapper,
} from './styles';

export const FloatingButton: React.FC = () => {
  const [isShowFaqModal, setIsShowFaqModal] = useState<boolean>(false);
  const [isShowManualModal, setIsShowManualModal] = useState<boolean>(false);
  const [dataFaq, setDataFaq] = useState<[]>([]);
  const [dataManual, setDataManual] = useState<[]>([]);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const fabRef = useRef(null);
  const [pathLocation, setPathLocation] = useState<string>('');
  const location = useLocation();

  const URL_SERVER = '/manual/baixar/';
  let url_atual = window.location.pathname;

  useEffect(() => {
    setPathLocation(location.pathname);
  }, [location.pathname]);

  // Data

  const fetchDataFaq = useCallback(async () => {
    try {
      const response = await api.get('/faq');
      return response.data;
    } catch (err) {
      console.log(err);
    }
  }, []);

  const fetchDataManual = useCallback(async () => {
    try {
      const response = await api.get('/manual');
      return response.data;
    } catch (err) {
      console.log(err);
    }
  }, []);

  const fetchDataTela = useCallback(async () => {
    try {
      const response = await api.get('/tela');
      return response.data;
    } catch (err) {
      console.log(err);
    }
  }, []);

  async function handleLoadData() {
    const faqs = await fetchDataFaq();
    const manuals = await fetchDataManual();
    const screens = await fetchDataTela();
    let pageId = 0;
    screens.forEach((item: any) => {
      if (url_atual === item.url) {
        pageId = item.id;
      }
    });
    filterFAQforScreen(faqs, pageId);
    filterManualforScreen(manuals, pageId);
  }

  function filterFAQforScreen(faqs: any, pageId: any) {
    const screenFAQ = faqs.filter((item: any) => item.idTelas.includes(pageId));

    setDataFaq(screenFAQ);
  }

  function filterManualforScreen(manuals: any, pageId: any) {
    const screenManual = manuals.filter((item: any) =>
      item.listaDeTelas.includes(pageId),
    );

    setDataManual(screenManual);
  }

  // Baixar PDF
  async function handleDownloadManual(id: string) {
    const manualPath = URL_SERVER + id;
    const response = await api.get(manualPath, {
      responseType: 'arraybuffer',
    });
    const url = URL.createObjectURL(
      new Blob([response.data], {
        type: 'application/pdf',
      }),
    );
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('target', '_blank');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  // Ações dos Modais

  const closeModal = () => {
    setIsShowFaqModal(false);
    setIsShowManualModal(false);
  };

  const openFaqModal = () => {
    setIsShowFaqModal(true);
  };

  const openManualModal = () => {
    setIsShowManualModal(true);
  };

  const toggleActionsFab = () => {
    setIsOpen(!isOpen);
    handleLoadData();
  };

  // Remover Fab Actions ao clicar fora do componente

  const handleOutsideAlerter = (ref: any) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
      function handleClickOutside(event: any) {
        if (ref.current && !ref.current.contains(event.target)) {
          setIsOpen(false);
        }
      }
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [ref]);
  };

  handleOutsideAlerter(fabRef);

  // Show / Hide Floating Button

  const [isScrolling, setIsScrolling] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.onscroll = () => {
        let currentScrollPos = window.pageYOffset;
        let maxScroll = document.body.scrollHeight - window.innerHeight;

        if (currentScrollPos >= maxScroll - 227) {
          setIsScrolling(true);
          setIsOpen(false);
        } else {
          setIsScrolling(false);
        }
      };
    }
  }, []);

  // Ubots

  // let script = document.createElement('script');
  // script.type = 'text/javascript';
  // script.id = 'debugScript';

  return (
    <>
      {pathLocation === '/' || pathLocation === '**' ? null : (
        <div ref={fabRef}>
          <>
            <Modal
              show={isShowFaqModal}
              titulo={'Lista de perguntas disponíveis para esta página.'}
              onCancel={() => closeModal()}
            >
              {dataFaq.map((data: any, index: number) => {
                return (
                  <Accordion
                    id={hash(index)}
                    key={index}
                    title={data.pergunta}
                    description={data.resposta}
                  />
                );
              })}
            </Modal>
            <Modal
              show={isShowManualModal}
              titulo={'Lista de manuais disponíveis.'}
              onCancel={() => closeModal()}
            >
              {dataManual.map((data: any, index: number) => {
                return (
                  <>
                    <DataWrapper key={index}>
                      <b> {data.tituloArquivo}</b>
                      <DataFile>
                        <p>{data.nomeManual}</p>
                        <Button
                          variant={'outline'}
                          onClick={() =>
                            setTimeout(() => {
                              handleDownloadManual(data.id);
                            }, 500)
                          }
                          size={'small'}
                        >
                          Visualizar
                        </Button>
                      </DataFile>
                    </DataWrapper>
                  </>
                );
              })}
            </Modal>
            <Container>
              <ActionsFab style={isOpen ? { visibility: 'visible' } : null}>
                <Fab
                  className={isOpen ? 'active' : ''}
                  onClick={() => {
                    setTimeout(() => {
                      toggleActionsFab();
                      openFaqModal();
                    }, 300);
                  }}
                  disabled={!dataFaq.length ? true : false}
                >
                  <QuestionIcon width={26} />
                  <span className="tooltip">FAQ</span>
                </Fab>
                <Fab
                  className={isOpen ? 'active' : ''}
                  onClick={() => {
                    setTimeout(() => {
                      toggleActionsFab();
                      openManualModal();
                    }, 300);
                  }}
                  disabled={!dataManual.length ? true : false}
                >
                  <DarfIcon width={26} />
                  <span className="tooltip">Manuais</span>
                </Fab>
              </ActionsFab>

              <Fab
                aria-label="add"
                onClick={toggleActionsFab}
                className={isScrolling ? 'show' : ''}
              >
                <Hamburger className="menu-open-button" htmlFor="menu-open">
                  <span
                    className={isOpen ? 'hamburger-1 active' : 'hamburger-1'}
                  ></span>
                  <span
                    className={isOpen ? 'hamburger-2 active' : 'hamburger-2'}
                  ></span>
                  <span
                    className={isOpen ? 'hamburger-3 active' : 'hamburger-3'}
                  ></span>
                </Hamburger>
              </Fab>
            </Container>
          </>
        </div>
      )}
    </>
  );
};
